import axios from "axios";

export const BASE_URL = "https://dev.glpapps.com/glpadmin/digital_contract";

export const authApi = axios.create({
  baseURL: BASE_URL,
  withCredentials: false,
});

authApi.defaults.headers.common["Content-Type"] = "application/json";

authApi.interceptors.response.use(
  (response) => {
    return response;
  },
  async (error) => {
    return Promise.reject(error);
  }
);

export const formDataApi = axios.create({
  baseURL: BASE_URL,
  withCredentials: false,
});

formDataApi.defaults.headers.common["Content-Type"] = "multipart/form-data";

formDataApi.interceptors.response.use(
  (response) => {
    return response;
  },
  async (error) => {
    return Promise.reject(error);
  }
);
